import type { MoveMainTrackBoxAction } from '../timelineActions';
import type { TimelineInternalOps } from '../../timelineInternalOps';


export function moveMainTrackBox(timelineInternalHelper: TimelineInternalOps, action: MoveMainTrackBoxAction) {
  action.undo = timelineInternalHelper.moveMainVideoTrackBox(action.sourceIndex, action.targetIndex);
}

